import { useFlowStore } from '@/store/flowStore'
import type { Objetivo } from '@/types'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const ResultRoute = lazyRouteComponent(() => import('@/features/result/Result'), 'Result')

function parseObjectives(value: unknown): string[] {
  if (!Array.isArray(value)) return []

  const seen = new Set<string>()
  const parsed: string[] = []
  for (const item of value) {
    if (typeof item !== 'string' || item.length === 0 || seen.has(item)) continue
    seen.add(item)
    parsed.push(item)
  }
  return parsed
}

export const Route = createFileRoute('/resultado')({
  component: ResultRoute,
  beforeLoad: () => {
    const {
      completed,
      steps,
      index,
      selectedObjective,
      selectedObjectives,
      context,
      setSelectedObjective,
      setSelectedObjectives,
    } = useFlowStore.getState()

    const flowObjective =
      typeof context.vars.objetivo === 'string' ? (context.vars.objetivo as string) : ''
    const flowObjectives = parseObjectives(context.vars.objetivos)
    const effectiveObjectives =
      flowObjectives.length > 0
        ? flowObjectives
        : selectedObjectives.length > 0
          ? selectedObjectives
          : flowObjective
            ? [flowObjective]
            : []
    const allCandidates = [flowObjective, ...effectiveObjectives, selectedObjective].filter(Boolean)
    const effectivePrimary = allCandidates.find((candidate) => typeof candidate === 'string') || ''
    const hasCompletedFlow = completed || (steps.length > 0 && index >= steps.length)

    if (!hasCompletedFlow || !effectivePrimary) {
      throw redirect({ to: '/objetivo' })
    }

    if (flowObjectives.length > 0) {
      setSelectedObjectives(flowObjectives as Objetivo[])
    } else if (flowObjective && selectedObjective !== flowObjective) {
      setSelectedObjective(flowObjective)
    }
  },
})
